import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import {SharedModule} from "../shared/shared.module";
import {RouterModule} from "@angular/router";
import {HttpClientModule} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { FlagsListComponent } from './components/flags-list/flags-list.component';

@NgModule({
  declarations: [
    HeaderComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
    exports: [
        HeaderComponent,
    ]
})
export class CoreModule { }
